module.exports = __webpack_public_path__ + "static/media/super-search-logo-color.0d0dabab.svg";